import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

import type { ICharacterCountProps } from './FormTextarea.types'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const ErrorText = styled.span`
    ${getFontStyle('p03Regular')}
    color: #dc2626;
    margin-top: 0.3rem;
    margin-left: 0.5rem;
    display: block;
`

export const CharacterCount = styled.span<ICharacterCountProps>`
    ${getFontStyle('p03Regular')}
    color: ${(props) => {
        if (props.$isOverLimit) return '#dc2626'
        if (props.$hasError) return '#dc2626'
        return '#6b7280'
    }};
    margin-top: 0.3rem;
    margin-left: 0.5rem;
    text-align: right;
    display: block;
`

export const TextareaWrapper = styled.div`
    position: relative;
    width: 100%;
`
